import * as React from 'react';
const CheckCircle = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={88} height={88} fill="none" {...props}>
    <mask
      id="a"
      width={88}
      height={88}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h88v88H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#1A73E9"
        d="m38.867 60.852 25.85-25.85-5.133-5.133-20.717 20.717-10.45-10.45-5.133 5.133 15.583 15.583Zm5.134 19.8c-5.073 0-9.84-.962-14.3-2.887-4.462-1.925-8.342-4.538-11.642-7.838-3.3-3.3-5.913-7.18-7.838-11.641-1.925-4.461-2.887-9.228-2.887-14.3 0-5.073.962-9.84 2.887-14.3 1.925-4.461 4.538-8.342 7.838-11.642 3.3-3.3 7.18-5.912 11.642-7.838C34.16 8.281 38.928 7.32 44 7.32c5.072 0 9.838.962 14.3 2.888 4.46 1.925 8.341 4.537 11.641 7.837 3.3 3.3 5.913 7.18 7.838 11.642 1.925 4.46 2.887 9.227 2.887 14.3 0 5.072-.962 9.839-2.887 14.3-1.925 4.46-4.538 8.341-7.838 11.641-3.3 3.3-7.18 5.913-11.641 7.838-4.462 1.925-9.228 2.887-14.3 2.887Z"
      />
    </g>
  </svg>
);
export default CheckCircle;
